import { makeStyles, createStyles } from '@material-ui/core';

export const useStylesProducView = makeStyles(theme =>
  createStyles({
    editor: {
      boxShadow: 'initial !important',
      padding: '0 !important',
    },
    container: {
      padding: '0',
      [theme.breakpoints.up('md')]: {
        padding: '0 100px',
      },
    },
    card: {
      padding: '50px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',

      [theme.breakpoints.up('md')]: {
        padding: '50px',
        maxWidth: '1280px',
        margin: 'auto',
      },
    },
    btn: {
      minWidth: 240
    },
    btnText: {
      fontSize: 17,
      fontWeight: 'bold',
      textTransform: 'initial'
    },
    leftCol: {
      maxWidth: '690px',
      [theme.breakpoints.up('md')]: {
        width: '60%',
        marginRight: '20px',
      },
    },
    rightCol: {
      width: '100%',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        width: '36%',
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
    name: {
      fontSize: 20,
      fontWeight: 600,
      margin: 0,

      [theme.breakpoints.up('md')]: {
        fontSize: 34,
        lineHeight: 1.2,
      },
    },
    price: {
      color: theme.palette.primary.main,
      fontSize: 20,
      fontWeight: 700,

      [theme.breakpoints.up('md')]: {
        fontSize: 34,
        margin: '15px 0',
      },
    },
    whatsAppButton: {
      width: '100%',
      height: 42,
      padding: '12px 20px',
      borderRadius: 4,
      backgroundColor: '#25d366',
      fontSize: 14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: '#fff',
      display: 'inline-block',
      marginTop: 20,

      '&:hover': {
        color: '#fff',
      },

      [theme.breakpoints.up('md')]: {
        width: 215,
      },
    },
    listItem: {
      marginBottom: 15,
    },
    listValue: {
      fontSize: 17,
      fontWeight: 700,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#000000',
      whiteSpace: 'break-spaces',
      margin: 0,
    },
    listValueImportant: {
      fontSize: 17,
      fontWeight: 700,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: theme.palette.primary.main,
      whiteSpace: 'break-spaces',
      margin: 0,
    },
    listKey: {
      marginBottom: 0,
      fontSize: 17,
      fontWeight: 400,
      color: '#757575',
    },
    companyCard: {
      top: 0,
      padding: '20px 25px',
      borderRadius: '4px',
      backgroundColor: 'rgba(208, 28, 31, 0.1)',
      marginTop: 50,
    },
    description: {
      fontSize: 17,
      fontWeight: 400,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '23px',
      letterSpacing: 'normal',
      color: '#000000',
      whiteSpace: 'break-spaces',
      margin: 0,
    },
    statisticsHeader: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',

      // marginBottom: 22,
      [theme.breakpoints.down(500)]: {
        alignItems: 'center',

        '& p': {
          fontSize: 23,
        },
      },
    },
    statisticsList: {
      marginBottom: 8,
    },
    ratingInfoText: {
      fontSize: 17,
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      margin: 0,
    },
    statisticsItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 8,
      whiteSpace: 'nowrap',
      fontWeight: 400,
      '& .progress': {
        background: '#d8d8d8',
        borderRadius: 12,
        height: 5,
        flex: 1,
        overflow: 'hidden',
        margin: '0 16px',
        '& span': {
          display: 'inline-block',
          height: '100%',
          background: '#d01c1f',
        },
      },
      // [theme.breakpoints.down(500)]: {
      //   '& p:first-child': {
      //     marginRight: `16px !important`,
      //     color: 'orange',
      //   },
      //   '& p:last-child': {
      //     marginLeft: `16px !important`,
      //     color: 'yellow',
      //   },
      // },
    },
    feedButton: {
      margin: '16px 0',
    },
  })
);
